import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { objectsToString, stringIsNullOrEmpty } from '../../utils/strings';

const styles = () => ({
    containerClassName: {
        overflow: 'auto',
        padding: 6,
        margin: -6,
        paddingLeft: 12,
        marginLeft: -12 // leave room for decorators
    }
});
const Table = withStyles(styles)(({ children, caption, thead, tbody, tfoot, columns, columnspans, ...props }) => {
    const { classes, sortableHeaderCell, className } = props;

    return (
        <div className={`table-container ${classes.containerClassName}`}>
            <table className={`table ${className || ''}`}>
                {caption && <caption>{caption}</caption>}
                {thead || (columns && (
                    <>
                        <colgroup>
                            {columns.map((column, columnIndex) => (
                                <col key={columnIndex} span={(!!columnspans && columnspans[columnIndex]) || null} />
                            ))}
                        </colgroup>
                        <thead>
                        <HeaderRow pad>
                            {columns.map((column, columnIndex) => (
                                <Cell
                                    dataLabel={column.label}
                                    colSpan={(!!columnspans && columnspans[columnIndex]) || null}
                                    key={column.label || columnIndex}
                                    tiny={column.tiny}
                                >
                                    {(sortableHeaderCell && sortableHeaderCell(column)) || column.label}
                                </Cell>
                            ))}
                        </HeaderRow>
                        </thead>
                    </>
                ))}
                {tbody || <tbody>{children}</tbody>}
                {tfoot}
            </table>
        </div>
    );
});

const HeaderRow = withStyles(styles)(({ pad, children, className }) => {
    return (
        <tr className={`row row--header ${pad ? 'row--padded' : ''} ${className || ''}`}>{children}</tr>
    );
});

const HeaderRowNested = withStyles(styles)(({ className, pad, children }) => {
    return <tr className={`row row--header-nested ${pad ? 'row--padded' : ''}  ${className || ''}`}>{children}</tr>;
});

const DraggableTableRowBase = props => {
    const { pad, children, variant, className, onClick, draggableProps, muiRef, style } = props;
    let cssVariant = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `row--${variant}`;

    return (
        <tr
            className={`row row--normal ${pad ? 'row--padded' : ''} ${className || ''} ${cssVariant || ''} ${(onClick &&
                'hasClick') || ''}`}
            onClick={onClick}
            ref={muiRef}
            style={style}
            {...draggableProps}
        >
            {children}
        </tr>
    );
};
const StyledDraggableTableRow = withStyles(styles)(DraggableTableRowBase);
const DraggableTableRow = React.forwardRef((props, ref) => <StyledDraggableTableRow {...props} muiRef={ref} />);

const RowNested = withStyles(styles)(({ pad, children, className, onClick }) => {
    return (
        <tr className={`row row--nested ${pad ? 'row--padded' : ''} ${className || ''}`} onClick={onClick}>
            {children}
        </tr>
    );
});

const Cell = withStyles(styles)(({ className, pad, children, dataLabel, colSpan, rowSpan, tiny }) => {
    return (
        <td
            className={`td ${pad ? 'td--padded' : false === pad ? 'td--not-padded' : ''} ${className || ''}`}
            data-label={!!dataLabel ? objectsToString(dataLabel) : null}
            colSpan={colSpan}
            rowSpan={rowSpan}
            style={{ width: tiny ? 1 : null }}
        >
            {children}
        </td>
    );
});

export default Table;
export { HeaderRow, HeaderRowNested, DraggableTableRow as Row, RowNested, Cell };
